import React from 'react';
import { FormattedMessage } from 'react-intl';
import { InputBox } from '../../../molecules/input-box';

export const SettingsSpLocation = () => {
  return (
    <>
      <InputBox
        title={
          <FormattedMessage
            id="settings.spot.latitude"
            defaultMessage="Zeměpisná šířka"
          />
        }
        inputVariableId="SP_LATITUDE"
        visibility={{ variableId: 'SP_INSTALL' }}
        label={
          <FormattedMessage
            id="settings.spot.latitude.mess"
            defaultMessage="Šířka"
          />
        }
        fullWidth
      />
      <InputBox
        title={
          <FormattedMessage
            id="settings.spot.longitude"
            defaultMessage="Zeměpisná délka"
          />
        }
        inputVariableId="SP_LONGITUDE"
        visibility={{ variableId: 'SP_INSTALL' }}
        label={
          <FormattedMessage
            id="settings.spot.longitude.mess"
            defaultMessage="Délka"
          />
        }
        fullWidth
      />
    </>
  );
};
